import React from 'react';
import { Check } from 'react-feather';

const OnboardingSteps = ({ activeStepButtonLeft = '-4px', progressComplete = '290px', activeStep = 1, className = '' }) => {
  const steps = [
    { id: 1, title: 'Upload credit reports' },
    { id: 2, title: 'Choose Items to be disputed' },
    { id: 3, title: 'Confirm personal information' },
    { id: 4, title: 'Upload documents' },
    { id: 5, title: 'Choose Mailing Option' },
    { id: 6, title: 'Disputes created' },
  ];

  const getButtonContent = stepId => {
    if (stepId < activeStep) {
      return <Check width={15} height={24} strokeWidth={3} />;
    }
    return stepId;
  };
  const [progressWidth, setProgressWidth] = React.useState(0);

  React.useEffect(() => {
    const timerId = setTimeout(() => {
      setProgressWidth(parseInt(progressComplete));
    }, 500);
    return () => clearTimeout(timerId);
  }, []);

  return (
    <div className='steps overflow-x-auto w-100 pb-3'>
      <div id='progress' style={{ appearance: '-webkit-appearance', position: 'absolute', zIndex: '5', border: '#c8ccdf dashed', borderWidth: '3px 0px 0px 0px', top: '5.25rem', left: '90px' }}></div>
      <div id='progress-complete' style={{ position: 'absolute', zIndex: '5', border: 'rgb(var(--bs-primary-rgb)) solid', borderWidth: '3px 0px 0px 0px', top: '5.25rem', width: `${progressWidth}px`, left: '90px', transition: 'width 2s cubic-bezier(0.25, 0, 0.5, 1)' }}></div>

      {steps.map((step, index) => {
        const isActive = step.id === activeStep;
        const isBeforeActive = step.id < activeStep;
        const isCompleted = step.id < activeStep;

        const buttonClassName = isActive ? 'step-button text-primary bg-light border border-2 border-primary text-center fw-bold' : isCompleted ? 'text-white bg-primary border border-2 border-primary text-center fw-bold' : 'step-button text-secondary bg-light border border-2 border-secondary text-center fw-bold';

        return (
          <div key={index} className={`step-item ${isActive ? 'active' : isCompleted ? 'completed' : ''}`}>
            <div className='step-title' style={{ width: '197px', fontWeight: '400', textAlign: 'center', marginBottom: '1.5rem', color: isCompleted ? '#000e4e' : '#7c84a5' }}>
              {step.title}
            </div>
            <button type='button' className={`step-button ${buttonClassName} p-0`} style={step.buttonStyle || {}}>
              {getButtonContent(step.id)}
            </button>

            {isActive && (
              <style>
                {`
               #progress {
                width: 85%;
              }
              .active .step-button {
                position: relative;
              }
              .active .step-button::after {
              content: '';
              position: absolute;
              top: -2px;
              left: ${activeStepButtonLeft};
              transform: translate(-50%, -50%);
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background-color: var(--bs-primary);
              animation: sonar 2s infinite;
              z-index: -1;
              }
              @keyframes sonar {
              0% {
                opacity: 1;
                transform: scale(0.5);
              }
              100% {
                opacity: 0;
                transform: scale(1.5);
              }
              }

@media (max-width: 767px) {
  .step-button {
    text-align: center;
  }
}


              `}
              </style>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OnboardingSteps;
